const reportPageMode = {
    create: 'create',
    edit: 'edit',
    readOnly: 'read-only'
};

export default reportPageMode;